import { css } from 'styled-components';

var typographyTemplate = function typographyTemplate(typography, link) {
  if (!typography) {
    return '';
  }
  var base = "\n  margin: 0;\n  color: ".concat(typography.color, ";\n  font-family: ").concat(typography.fontFamily, ";\n  font-size: ").concat(typography.fontSize, ";\n  font-weight: ").concat(typography.fontWeight, ";\n  line-height: ").concat(typography.lineHeight, ";\n  ");
  if (typography.fontStyle) {
    base += "\nfont-style: ".concat(typography.fontStyle, ";");
  }
  if (typography.letterSpacing) {
    base += "\nletter-spacing: ".concat(typography.letterSpacing, ";");
  }
  if (typography.textTransform) {
    base += "\ntext-transform: ".concat(typography.textTransform, ";");
  }
  if (typography.textDecoration) {
    base += "\ntext-decoration: ".concat(typography.textDecoration, ";");
  }
  if (typography.textAlign) {
    base += "\ntext-align: ".concat(typography.textAlign, ";");
  }
  if (typography.fontFeature) {
    base += "\nfont-feature-settings: ".concat(typography.fontFeature, ";");
  }
  if (link) {
    base += "\ncursor: pointer;";
  }
  return base;
};
var spacingsTemplate = function spacingsTemplate(_ref) {
  var left = _ref.left,
    right = _ref.right,
    top = _ref.top,
    bottom = _ref.bottom;
  return css({
    paddingLeft: left,
    paddingTop: top,
    paddingRight: right,
    paddingBottom: bottom
  });
};
var boxshadowTemplate = function boxshadowTemplate(border) {
  return css({
    boxShadow: "inset 0 -".concat(border.width, " 0 0 ").concat(border.color, ";")
  });
};

export { boxshadowTemplate, spacingsTemplate, typographyTemplate };
